'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const CircularityMaintainRepairIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_23863_5621)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M23.0021 4.41689C21.8886 2.87771 19.9237 2.02625 17.4535 2.02625C17.0325 2.02625 16.5927 2.04496 16.1576 2.09642V3.49057C16.6067 3.43443 17.0325 3.40636 17.4535 3.40636C18.8758 3.40636 20.8032 3.72449 21.8933 5.22157C22.8851 6.61105 22.8617 8.63678 21.8091 10.9385C21.2617 12.1549 20.457 13.3619 19.4559 14.4988C18.4547 15.645 17.2524 16.7304 15.9143 17.6894C12.85 19.8789 9.42545 21.128 6.54825 21.128C5.12603 21.128 3.19854 20.8193 2.10848 19.3128C1.11667 17.9327 1.14006 15.9023 2.19269 13.6052C2.35175 13.2543 2.53889 12.9128 2.7307 12.5619H1.16345C1.07456 12.721 0.999706 12.8707 0.929531 13.0298C-0.333629 15.7994 -0.305559 18.3163 0.990349 20.1175C2.10848 21.6614 4.07807 22.5081 6.54825 22.5081C9.71551 22.5081 13.4161 21.1608 16.719 18.8169C19.6103 16.7538 21.8699 14.1573 23.0769 11.5046C24.3261 8.73502 24.312 6.22274 23.0068 4.41689H23.0021Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.5123 14.5312L13.9497 16.964L14.9415 15.9722L11.8351 12.8657L11.3906 13.0669C9.71574 13.8342 7.71808 13.4786 6.41749 12.178C5.37889 11.1394 4.94381 9.64699 5.21047 8.22945L7.152 10.171C7.62919 10.6482 8.26077 10.9102 8.93445 10.9102C9.60814 10.9102 10.2397 10.6482 10.7169 10.171C11.1941 9.69378 11.4561 9.0622 11.4561 8.38851C11.4561 7.71483 11.1941 7.08325 10.7169 6.60605L8.79878 4.68792C10.3801 4.4119 12.0316 5.02009 13.0608 6.33939C14.0386 7.59319 14.2491 9.36161 13.5988 10.84L13.407 11.2798L16.5228 14.3956L17.5146 13.4038L15.0631 10.9523C15.69 9.10898 15.3626 7.00839 14.1696 5.47857C12.5181 3.35927 9.65024 2.63412 7.19878 3.7195L6.26311 4.1312L9.72978 7.59787C10.1649 8.03296 10.1649 8.73939 9.72978 9.17448C9.30872 9.59553 8.57422 9.59553 8.15317 9.17448L4.68649 5.70781L4.26544 6.62945C3.25959 8.83764 3.72743 11.4669 5.43503 13.1698C7.03036 14.7652 9.421 15.2845 11.5263 14.5312H11.5123Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_23863_5621", children: /* @__PURE__ */ jsx("rect", { width: 24, height: 24, fill: "currentColor" }) }) })
    ]
  }
);
const VpCircularityMaintainRepairIcon = forwardRef(CircularityMaintainRepairIcon);

export { VpCircularityMaintainRepairIcon as default };
